class C2APictureVideo {
  public items: any;
  public switch: any;

  bindings() {
    if (this.items) {
      /* Object.values(this.items).forEach((item: any) => {
        let video = item.querySelectorAll('video')[0];
        item.onclick = (inner : any) => {
          if(video.paused)
          video.play();
          else
          video.pause();
        }
      }); */
      Object.values(this.items).forEach((item: any) => {
        const btn = item.querySelector('.a-button');
        if (btn && item.dataset.lightboxvideo) {
          btn.onclick = (e: MouseEvent) => {
            e.preventDefault();
          }
        }
      })
    }
  }

  cache() {
    this.items = document.querySelectorAll('.js-cta-w-picture-video-switch');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default C2APictureVideo;
